import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const career = {
  careerList: (params) => {
    const url = api.career.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  careerDetail: (id) => {
    const url = api.career.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  careerCreate: (payloads) => {
    const url = api.career.create
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  careerDelete: (id) => {
    const url = api.career.delete(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  careerUpdate: (payloads, id) => {
    const url = api.career.update(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  submissionsList: (params) => {
    const url = api.career.submissions + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  submissionDetail: (id) => {
    const url = api.career.submissionDetail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateSubmissionStatus: (id, payloads) => {
    const url = api.career.updateSubmissionStatus(id)
    return baseURL.patch(url, payloads, { headers: getAuthHeader() })
  },
  deleteSubmission: (id) => {
    const url = api.career.deleteSubmission(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  careerSubmissions: (careerId) => {
    const url = api.career.careerSubmissions(careerId)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}

export default career
